// import React, { useState, useRef } from 'react';
import React, { useState, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import DraftContext from 'context/DraftContext';
import ToolBarPortal from './ToolBarPortal';
import ExternalToolbar from './ExternalToolbar';
import useWindowDimensions from 'hooks/useWindowDimensions';
import './Toolbar.scss';

const ToolBar = ({
  bodyFont,
  language,
  editorState,
  onToggle,
  onToggleBlockType,
  onToggleFontInlineStyle,
  onToggleCustomBockStyle,
  onClearFormatting,
  onSplitSection,
  dispatch,
  zoomValue,
  selectionActive,
  isSection,
  ...rest
}) => {
  const { collapse, collapseContentTable } = useContext(DraftContext);
  const { width } = useWindowDimensions();
  const [lineHeightDropDownVisible, setLineHeightDropDownVisible] = useState(false);

  const toggleLineHeightDropDown = (value) => {
    setLineHeightDropDownVisible(value);
    dispatch({ type: 'setLineHeightInput', lineHeightInput: value });
  };

  const getComputedStyle = useMemo(() => {
    const sidemenuActive = !collapse;
    const contentTableActive = !collapseContentTable;

    let style = { '--translate-factor': '0px' };

    if (width >= 1300) {
      style.width = 'calc(100% - 64px)';
    }

    if (width >= 1500) {
      if (contentTableActive && sidemenuActive) {
        // both TOC and sidemenu open
        return {
          ...style,
          width: 'calc(74% - 190px)',
          '--translate-factor': '245px',
        };
      } else if (contentTableActive) {
        // TOC open
        return {
          ...style,
          transform: 'translateX(-50%)',
          '--translate-factor': 'calc(50% + 120px)',
        };
      } else if (sidemenuActive) {
        // sidemenu open
        return {
          ...style,
          width: 'calc(74% - 150px)',
          '--translate-factor': '60px',
        };
      } else {
        // both TOC and sidemenu close
        return {
          ...style,
          transform: 'translateX(-50%)',
          '--translate-factor': 'calc(50% - 6px)',
        };
      }
    } else if (width >= 1300) {
      if ((contentTableActive && sidemenuActive) || sidemenuActive) {
        // both TOC and sidemenu open, or sidemenu open
        style['--translate-factor'] = '64px';

        if (sidemenuActive) {
          return { ...style, justifyContent: 'flex-start' };
        }

        return { ...style };
      } else if (contentTableActive) {
        return {
          ...style,
          '--translate-factor': '64px',
        };
      } else {
        return {
          ...style,
          transform: 'translateX(-50%)',
          '--translate-factor': 'calc(50% + 6px)',
        };
      }
    } else if (width >= 992) {
      return {
        ...style,
        '--translate-factor': '60px',
      };
    }

    return style;
  }, [width, collapse, collapseContentTable]);

  return (
    <ToolBarPortal>
      <div
        className={`rich-editor-toolbar-header ${collapse ? 'collapsed' : ''}`}
        // style={getComputedStyle(!collapse, !collapseContentTable)}
        style={getComputedStyle}>
        <div className="rich-editor-toolbar">
          <ExternalToolbar
            selectionActive={selectionActive}
            language={language?.toLowerCase()}
            bodyFont={bodyFont}
            editorState={editorState}
            onToggle={onToggle}
            onToggleBlockType={onToggleBlockType}
            onToggleFontInlineStyle={onToggleFontInlineStyle}
            onToggleCustomBockStyle={onToggleCustomBockStyle}
            onClearFormatting={onClearFormatting}
            onSplitSection={onSplitSection}
            dispatch={dispatch}
            isSection={isSection}
            toggleLineHeightDropDown={toggleLineHeightDropDown}
            lineHeightDropDownVisible={lineHeightDropDownVisible}
            {...rest}
          />
        </div>
      </div>
    </ToolBarPortal>
  );
};

ToolBar.defaultProps = {
  bodyFont: '',
  zoomValue: 100,
  selectionActive: false,
};

ToolBar.propTypes = {
  bodyFont: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
  language: PropTypes.string.isRequired,
  editorState: PropTypes.instanceOf(Object).isRequired,
  onToggle: PropTypes.func.isRequired,
  onToggleBlockType: PropTypes.func.isRequired,
  onToggleFontInlineStyle: PropTypes.func.isRequired,
  onToggleCustomBockStyle: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  onClearFormatting: PropTypes.func.isRequired,
  onSplitSection: PropTypes.func.isRequired,
  zoomValue: PropTypes.number,
  selectionActive: PropTypes.bool,
  user: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  isSection: PropTypes.bool,
};

export default ToolBar;
